import { apiUrl } from "../constans";
import apiClient from '../libs/axios';

const API_BASE = `${apiUrl}/v2/lonjas`;

const lonja = {
    namespaced: true,
    state: {
        lonjas: {
            data: [],
            current_page: 1,
            per_page: 15,
            last_page: 1,
            total: 0,
        },
        lonjaDetail: null,
        loading: false,
        error: null,
    },

    mutations: {
        setLonjas(state, lonjas) {
            const stat = state.lonjas;
            stat.data = lonjas.data;
            stat.current_page = lonjas.current_page;
            stat.per_page = lonjas.per_page;
            stat.total = lonjas.total;
            stat.last_page = lonjas.last_page;
        },

        setCurrentPage(state, page) {
            state.lonjas.current_page = page;
        },

        setLonjaDetail(state, lonjaData) {
            state.lonjaDetail = lonjaData;
        },

        addLonja(state, lonjaData) {
            state.lonjas.data.unshift(lonjaData);
            state.lonjas.total = (state.lonjas.total || 0) + 1;
        },

        updateLonja(state, updatedLonja) {
            const index = state.lonjas.data.findIndex((item) => item.id === updatedLonja.id);
            if (index !== -1) {
                state.lonjas.data[index] = updatedLonja;
            }
            if (state.lonjaDetail && state.lonjaDetail.id === updatedLonja.id) {
                state.lonjaDetail = { ...state.lonjaDetail, ...updatedLonja };
            }
        },

        removeLonja(state, lonjaId) {
            state.lonjas.data = state.lonjas.data.filter((item) => item.id !== lonjaId);
            state.lonjas.total = Math.max((state.lonjas.total || 1) - 1, 0);
        },

        addMemberToDetail(state, user) {
            if (!state.lonjaDetail) return;
            if (!Array.isArray(state.lonjaDetail.inmobiliarias)) {
                state.lonjaDetail.inmobiliarias = [];
            }
            state.lonjaDetail.inmobiliarias.push(user);
        },

        removeMemberFromDetail(state, userId) {
            if (!state.lonjaDetail || !Array.isArray(state.lonjaDetail.inmobiliarias)) return;
            state.lonjaDetail.inmobiliarias = state.lonjaDetail.inmobiliarias.filter(
                (u) => u.id !== userId
            );
        },

        clearLonjaDetail(state) {
            state.lonjaDetail = null;
        },

        setLoading(state, loading) {
            state.loading = loading;
        },

        setError(state, error) {
            state.error = error;
        },

        clearError(state) {
            state.error = null;
        },
    },

    actions: {
        async getLonjasAction({ commit }, { filters = {}, page = 1 } = {}) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const params = { page, ...filters };
                const response = await apiClient.get(API_BASE, { params });
                const payload = response.data.data || response.data;

                if (payload && Array.isArray(payload.data)) {
                    commit('setLonjas', payload);
                } else if (Array.isArray(payload)) {
                    commit('setLonjas', {
                        data: payload,
                        current_page: 1,
                        per_page: payload.length,
                        last_page: 1,
                        total: payload.length,
                    });
                }
                return payload;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al cargar lonjas');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async getLonjaDetailAction({ commit }, lonjaId) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.get(`${API_BASE}/${lonjaId}`);
                const data = response.data.data || response.data;
                commit('setLonjaDetail', data);
                return data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al cargar lonja');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async createLonjaAction({ commit }, lonjaData) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.post(API_BASE, lonjaData);
                const data = response.data.data || response.data;
                commit('addLonja', data);
                return data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al crear lonja');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async updateLonjaAction({ commit }, { lonjaId, data }) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.put(`${API_BASE}/${lonjaId}`, data);
                const result = response.data.data || response.data;
                commit('updateLonja', result);
                return result;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al actualizar lonja');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async deleteLonjaAction({ commit }, lonjaId) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.delete(`${API_BASE}/${lonjaId}`);
                commit('removeLonja', lonjaId);
                return response.data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al eliminar lonja');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async toggleActiveAction({ commit }, { lonjaId, active }) {
            commit('setLoading', true);
            commit('clearError');
            try {
                const response = await apiClient.put(`${API_BASE}/${lonjaId}`, { active });
                const result = response.data.data || response.data;
                commit('updateLonja', result);
                return result;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al cambiar estado');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async addMemberAction({ commit }, { lonjaId, userId }) {
            commit('clearError');
            try {
                const response = await apiClient.post(`${API_BASE}/${lonjaId}/members`, {
                    user_id: userId,
                });
                const data = response.data.data || response.data;
                if (data && data.id) {
                    commit('addMemberToDetail', data);
                }
                return data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al agregar miembro');
                throw error;
            }
        },

        async removeMemberAction({ commit }, { lonjaId, userId }) {
            commit('clearError');
            try {
                const response = await apiClient.delete(`${API_BASE}/${lonjaId}/members/${userId}`);
                commit('removeMemberFromDetail', userId);
                return response.data;
            } catch (error) {
                commit('setError', error.response?.data?.message || 'Error al remover miembro');
                throw error;
            }
        },

        async searchMainUsersAction(_, { query = '', page = 1 } = {}) {
            const params = { is_main: 1, page };
            if (query) params.search = query;
            const response = await apiClient.get(`${apiUrl}/v2/users`, { params });
            return response.data.data || response.data;
        },

        async getUserLonjasAction(_, userId) {
            const response = await apiClient.get(`${apiUrl}/v2/users/${userId}/lonjas`);
            return response.data.data || response.data;
        },
    },
};

export default lonja;
